<div class="ng-scope">
    <nav class="navbar navbar-expand-lg navbar-light">
        <a class="navbar-brand" href="#">OPS SHEET</a>
    </nav>

    <div class="container-fluid" style="margin-bottom: 1em; padding-left: 0; padding-right: 0;">
        <form class="example-form">
            <div class="card">
                <div class="card-header">
                    <button class="btn ng-binding" style="float: right;" (click)="toggle()">
                        {{buttonName}}
                    </button>
                </div>

                <div class="card-body animate-show-hide" id="filterGroup" *ngIf="ShowFilters">
                    <div class="row">
                        <div class="col-sm-1">
                            <b>
                                Client
                            </b>
                        </div>

                        <div class="col-sm-3">
                            <mat-form-field appearance="fill">
                                <mat-label>select</mat-label>
                                <mat-select>
                                    <mat-option *ngFor="let cust of custs" [value]="cust.value">
                                        {{cust.viewValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-2">
                            <b>
                                Appraisal Company Name
                            </b>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field appearance="fill">
                                <input matInput type="text">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row" style="margin-top: 1em;">
                        <div class="col-sm-1">
                            <b>
                                From
                            </b>
                        </div>
                        <div class="col-sm-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Choose a date</mat-label>
                                <input matInput [matDatepicker]="picker" name="from" id="from">
                                <mat-hint>MM/DD/YYYY</mat-hint>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-1">
                            <b>
                                To
                            </b>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field appearance="fill">
                                <mat-label>Choose a date</mat-label>
                                <input matInput [matDatepicker]="pickers" name="to" id="to">
                                <mat-hint>MM/DD/YYYY</mat-hint>
                                <mat-datepicker-toggle matSuffix [for]="pickers"></mat-datepicker-toggle>
                                <mat-datepicker #pickers></mat-datepicker>
                            </mat-form-field>
                        </div>
                        </div>

                        <div class="row" style="margin-top: 3cm;">
                            <div class="col-sm-2">
                                <button mat-button ng-click="$ctrl.searchClicked()" type="button"
                                    class="btn btn-primary">
                                    SEARCH
                                </button>
                            </div>

                            <div class="col-sm-5">
                                <button mat-button ng-click="$ctrl.exportCashProData()" id="submitBtn" type="button"
                                    class="btn btn-primary">
                                    Export CashPro csv
                                </button>
                            </div>

                            <div class="col-sm-5" id="popupDiv"
                                style="border: 1px solid #212529;margin:-129px 10px 0px auto;background-color: antiquewhite;border-radius: 10px; height:fit-content;">
                                <ul id="popupRest" style="font-size:12px;">
                                    <li>For regular weekday processing, simply choose the given weekday as the “From
                                        Date” and the “To Date”</li>
                                    <li>For day-after-the-weekend processing, simply choose the date range of Saturday
                                        through (and including) Monday</li>
                                    <li>For the day after a Monday holiday, simply choose the date range of Saturday
                                        through (and including) Tuesday</li>
                                    <li>For the day after a non-Monday holiday, simply choose the date range of that
                                        holiday through (and including) the day after the holiday.</li>
                                </ul>
                            </div>
                            <div style="margin-left: 10px;">
                                <p id="postCountText" style="font-size: smaller;"></p>
                            </div>
                        </div>
                    </div>